module.exports = __webpack_public_path__ + "media/images/river/crewneck-honey-2f826b8e8f46e56a97f0d1002b534883.jpg";